// Styles for inline ReactTable elements

export const tableStyles = {
    footer: {fontSize: 13, fontWeight: 600, textAlign: 'right'},
    hide: {display: 'none'},

    thGroupMin: {width: 220, minWidth: 220},
    thSmall: {fontSize: 11},
    thLast: {borderRight: '1px solid #bdbdbd'},

    tdMax: {width: 90, maxWidth: 90},
    tdMin: {width: 110, minWidth: 110},
    tdMin180: {width: 180, minWidth: 180},

    tableIconButton: {
        display: 'inline-block',
        width: 40,
        height: 26,
        color: '#262360',
        padding: '0 0 0 10px',
        verticalAlign: 'middle',
        cursor: 'pointer'
    },
    disabledTableIconButton: {
        display: 'inline-block',
        width: 40,
        height: 26,
        color: 'rgba(33,33,33,0.3)',
        padding: '0 0 0 10px',
        verticalAlign: 'middle',
        cursor: 'pointer',
        pointerEvents: 'none',
        opacity: '0.7'
    },

    left: {textAlign: 'left'},
    center: {textAlign: 'center'},
    right: {textAlign: 'right'},
    rightSortable: {textAlign: 'right', paddingRight: 18},

    wrapText: {wordWrap: 'break-word'},
    noPadding: {padding: 0},

    subcomponent: {
        display: 'table-cell',
        padding: 0,
        height: 'auto',
        minHeight: 48,
        fontSize: 13,
        borderBottom: 'none',
    },
};



// WEBPACK FOOTER //
// ./src/Fuse/shared/styles-table.js